var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.auth.authenticated ? `` : `container-fluid`},[(_vm.auth.authenticated)?_c('signed-in'):_vm._e(),(!_vm.auth.authenticated)?_c('not-signed-in'):_vm._e(),(_vm.flash.active)?_c('flash'):_vm._e(),_c('app-tour')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }